import { render, staticRenderFns } from "./VehicleAssess.vue?vue&type=template&id=766d772a&scoped=true&"
import script from "./VehicleAssess.vue?vue&type=script&lang=js&"
export * from "./VehicleAssess.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAssess.vue?vue&type=style&index=0&id=766d772a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d772a",
  null
  
)

export default component.exports